import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const DutyType = types.compose(
  BaseEntity,
  types.model('DutyType', {
    dutyTypeId: types.identifierNumber,
    name: types.string,
    type: types.enumeration(['DAY', 'NIGHT']),
  }),
);
